// extracted by mini-css-extract-plugin
module.exports = {"warning":"Alert_warning_3tISE"};